import type { CategoryListItem } from '@/types/apis/Category';
import type { ClassValue } from 'clsx';

import React from 'react';
import Link from 'next/link';

import { cn } from '@/lib/utils';

type Props = {
  className?: ClassValue;
  content: CategoryListItem;
  link: string;
};

const LessonCategoryCard: React.FC<Props> = ({ className, content, link }) => {
  return (
    <Link href={link}>
      <div
        className={cn(
          'w-full relative aspect-[53/50] bg-cover bg-center rounded-2xl overflow-hidden',
          className
        )}
        style={{
          backgroundImage: `url(${content.image})`,
        }}
      />
    </Link>
  );
};

export default LessonCategoryCard;
